import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../styles/FormError.module.scss';

const cx = classNames.bind(styles);

const EnrollmentFormError = ({ errorField, errorText, blockError }) => {
  if (!errorField) {
    return null;
  }
  const defaultText = {
    required: 'This field is required',
    pattern: 'Please check what you have entered is correct',
    minLength: 'Your response is too short',
    maxLength: 'Your response is too long',
    default: 'Please check this field is correct',
  };
  const renderText = { ...defaultText, ...errorText };
  const errorMessage = renderText[errorField.type] || renderText.default;

  return <p className={cx('EnrollmentFormError', { blockError })}>{errorMessage}</p>;
};

EnrollmentFormError.defaultProps = {
  errorField: null,
  errorText: {},
  blockError: false,
};

const errorFieldShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
});

const errorTextShape = PropTypes.shape({
  required: PropTypes.string,
  pattern: PropTypes.string,
  default: PropTypes.string,
});

EnrollmentFormError.propTypes = {
  errorField: errorFieldShape,
  errorText: errorTextShape,
  blockError: PropTypes.bool,
};

export default EnrollmentFormError;
